import React, { useEffect, useState } from 'react';
import { Button, Col, Row, Modal, OverlayTrigger, Tooltip, Form as BootstrapForm } from 'react-bootstrap';
import FormField from '../layout/FormField';
import FormSelect from '../layout/FormSelect';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import viewIcon from '../../assets/images/icons/viewModalIcon.svg';
import editIcon from '../../assets/images/icons/icon-edit.svg';
import delIcon from '../../assets/images/icons/icon-delete.svg';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import _ from 'lodash';
import CommonModal from '../Modals/CommonModal';
import moment from 'moment';
import { useAuth } from '../../hooks/useAuth';
import { validateFileType } from '../../helpers/utils';
import ReactSelect from 'react-select';
import AddressInputWithMapClick from '../Modals/VendorModals/AddressInputWithMapClick';

const customStyles = {
    rows: {
        style: {
            // minHeight: '72px' // override the row height
            textAling: 'center'
        }
    },
    headCells: {
        style: {
            paddingLeft: '8px', // override the cell padding for head cells
            paddingRight: '8px',
            backgroundColor: '#13aa61',
            color: 'white',
            '&:hover': {
                cursor: 'pointer'
            }
        }
    }
};
const EditVendors = () => {
    const [vendorDetials, setVendorDetail] = useState();
    const [vendorLogo, setVendorLogo] = useState();
    const [rewards, setRewards] = useState();
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [status, setStatus] = useState('');
    const [vendorType, setVendorType] = useState('');
    const [toggleCleared, setToggleCleared] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [buttonDisable, setButtonDisable] = useState(false);
    const [isFilterSelected, setIsFilterSelected] = useState(false);
    const [isTypeFilterSelected, setIsTypeFilterSelected] = useState(false);
    const [changeStatusModal, setChangeStatusModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showDelModal, setShowDelModal] = useState(false);
    const [isValidSelected, setIsValidSelected] = useState(false);
    const [updateLogo, setUpdateLogo] = useState(false);
    const [selectedItem, setSelectedItem] = useState();
    const { state } = useLocation();
    const { getToken } = useAuth();
    const navigate = useNavigate();
    const [transitAgencyOptions, setTransitAgencyOptions] = useState([]);
    const [vendorNames, setVendorNames] = useState([]);
    const [vendorLatLng, setVendorLatLng] = useState({ lat: '', lng: '' });

    const validate = Yup.object({
        name: Yup.string().required('Required'),
        email: Yup.string().email('Email is invalid').required('Required'),
        phone_number: Yup.string()
            .matches(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4,5}$/, "Your phone number format must be '+1 233-343-2342'")
            .required('Required'),
        vendor_website: Yup.string().matches(
            /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
            'Please enter a valid website url!'
        ),
        transit_agency: Yup.array().min(1, 'At least one transit agency is required').required('Required')
    });

    const getTransitAgencies = async () => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                .getAllAgencies(token, '', '', '', 'active', '')
                .then((res) => {
                    if (res?.code == 200) {
                        setTransitAgencyOptions((state) => {
                            const s = res?.data?.agencies?.map((item) => ({ value: item._id, label: item?.name }));
                            return s;
                        });
                    }
                })
                .catch((err) => {});
        }
    };

    const fetchVendors = async () => {
        const token = getToken();
        if (!token) return;

        const webApiCalls = new WebApiCalls();
        let pageNo = 1;
        const pageSize = 50;
        let allNames = [];

        try {
            while (true) {
                const res = await webApiCalls.getAllVendors(token, pageSize, pageNo);

                if (res?.code === 200) {
                    const vendors = res?.data?.vendors || [];
                    if (vendors?.length === 0) break;

                    // Store vendor names in lowercase
                    allNames.push(...vendors?.map((v) => v.name.toLowerCase()));

                    if (vendors?.length < pageSize) break;

                    pageNo++;
                } else {
                    console.error('Error fetching vendors:', res?.message);
                    break;
                }
            }
            setVendorNames(allNames); // ✅ Store vendor names in state
        } catch (error) {
            console.error('Error fetching vendors:', error);
        }
    };

    const validateForm = () => {
        let isValid = true;
        if (isNaN(vendorLatLng.lat) || vendorLatLng.lat === '') {
            isValid = false;
        }

        if (isNaN(vendorLatLng.lng) || vendorLatLng.lng === '') {
            isValid = false;
        }

        return isValid;
    };

    const handleSubmit = async (values, actions) => {
        const webApi = new WebApiCalls();
        try {
            let uploadedImage = null;
            const token = getToken();
            if (!token) return;

            if (validateForm()) {
                const transitAgencies = values.transit_agency?.map((item) => item.value);
                const originalName = vendorDetials?.name?.toLowerCase().trim();

                const newName = values.name?.toLowerCase().trim();

                // ✅ Only check uniqueness if name changed
                if (newName !== originalName && vendorNames.includes(newName)) {
                    toast.error('Vendor name already exists!');
                    return;
                }

                //upload only when user select new image
                if (updateLogo) {
                    if (vendorLogo && isValidSelected) {
                        const data = new FormData();
                        data.append('image', vendorLogo);
                        uploadedImage = await webApi.uploadImages(token, data);
                        values.vendor_logo = uploadedImage.data?.URL;
                    } else {
                        if (!isValidSelected) {
                            toast.error('Please select a valid image format');
                            return;
                        }
                        toast.error('Please select a logo image');
                        return;
                    }
                }

                webApi
                    .updateVendor(token, { ...values, status: status, vendor_type: vendorType, transit_agency: transitAgencies }, state?.vendor_id)
                    .then((res) => {
                        if (res?.code === 200) {
                            navigate('/vendors');
                            toast.success('Vendor is  updated successfully.');
                        }
                    })
                    .catch((err) => {
                        toast.success('Oops...! Something went wrong');
                    });
            }
        } catch (error) {
            console.error('ERROR while updating Bulk', error);
        }
    };

    useEffect(() => {
        if (state?.vendor_id && transitAgencyOptions?.length > 0) {
            getVendorDetail(state?.vendor_id);
            getVendorRewards(pageSize, 1, '', '', state?.vendor_id);
        }
    }, [state, transitAgencyOptions]);

    useEffect(() => {
        getTransitAgencies();
        fetchVendors();
    }, []);

    useEffect(() => {
        if (selectedRows && selectedRows.length > 0) {
            setButtonDisable(false);
        } else {
            setButtonDisable(true);
        }
    }, [selectedRows]);

    const getVendorDetail = async (id = '') => {
        const token = getToken();
        if (token && id) {
            new WebApiCalls()
                .getSingleVendor(token, id)
                .then((res) => {
                    if (res?.code === 200) {
                        const { data } = res;
                        setStatus(data?.status || 'inactive');
                        setVendorType(data?.vendor_type);

                        const transitAgencies = transitAgencyOptions.filter((item) => {
                            return data?.transit_agency?.includes(item.value);
                        });

                        setVendorDetail({
                            ...data,
                            transit_agency: transitAgencies || []
                        });

                        setVendorLatLng({
                            lat: data?.lat || '',
                            lng: data?.long || ''
                        });
                        if (data.logo != '') setUpdateLogo(false);
                    }
                })
                .catch((err) => {});
        }
    };

    const handlePerRowsChange = async (pageSize, pageNo) => {
        getVendorRewards(pageSize, pageNo, '', '', state?.vendor_id);
        setPageSize(pageSize);
    };

    const handlePageChange = (pageNo) => {
        getVendorRewards(pageSize, pageNo, '', '', state?.vendor_id);
    };

    const getVendorRewards = async (pageSize = 10, pageNo = 0, _status = '', _search = '', id = '') => {
        const token = getToken();
        if (id && token) {
            new WebApiCalls()
                .getAllRewards(token, pageSize, pageNo, '', '', '', id)
                .then((res) => {
                    if (res?.code === 200) {
                        setRewards(res?.data?.rewards);
                        setTotalRecords(res?.data?.totalCount);
                    }
                })
                .catch((err) => {
                    console.error('Error in Agency details:   ', err);
                });
        }
    };

    const columns = [
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Name</span>
                </h6>
            ),
            selector: (row) => row.name,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold ">Number of Allowed Redeems</span>
                </h6>
            ),
            selector: (row) => row.noOfAllowRedeems,
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Redeemed Count</span>
                </h6>
            ),
            selector: (row) => row?.redeemedCount,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Required Points</span>
                </h6>
            ),
            selector: (row) => row?.requiredPoints,
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Status</span>
                </h6>
            ),
            selector: (row) => (
                <select
                    value={row?.status}
                    onChange={(e) => {
                        e.preventDefault();
                        updateSingle(row?._id, { status: e.target.value });
                    }}
                    className={row?.status === 'inactive' ? 'status-selector-inactive' : 'status-selector'}
                    aria-label="Default select example"
                >
                    <option value={'active'}>Active</option>
                    <option value={'inactive'}>Inactive</option>
                </select>
            ),
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Validity</span>
                </h6>
            ),
            selector: (row) => (row?.validity ? moment(row?.validity).format('MM-DD-YYYY') : ''),
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Action</span>
                </h6>
            ),
            selector: (row) => (
                <div className="d-flex">
                    <div className="view-detail">
                        <OverlayTrigger placement={'bottom'} overlay={<Tooltip id={`tooltip-bottom`}>View details</Tooltip>}>
                            <div className="edit-detail">
                                <img
                                    width={15}
                                    className="me-3"
                                    src={viewIcon}
                                    alt=""
                                    onClick={() => {
                                        setSelectedItem(row);
                                        navigate('/reward-points/reward-point-details', {
                                            state: {
                                                reward_id: row._id,
                                                reward_details: row,
                                                redirect_url: '/agencies/edit-agency',
                                                agency_id: state?.agency_id,
                                                agency_details: state?.agency_details,
                                                type: state?.type
                                            }
                                        });
                                    }}
                                />
                            </div>
                        </OverlayTrigger>
                    </div>
                    <div className="edit-detail">
                        <OverlayTrigger placement={'bottom'} overlay={<Tooltip id={`tooltip-bottom`}>Edit reward</Tooltip>}>
                            <div className="edit-detail">
                                <img
                                    width={15}
                                    className="me-3"
                                    src={editIcon}
                                    alt=""
                                    onClick={() => {
                                        navigate('/reward-points/edit-rewards-points', {
                                            state: {
                                                reward_id: row._id,
                                                redirect_url: '/vendors/edit-vendor',
                                                vendor_id: state?.vendor_id,
                                                vendor_details: state?.agency_details,
                                                type: 'vendor'
                                            }
                                        });
                                    }}
                                />
                            </div>
                        </OverlayTrigger>
                    </div>

                    <div className="del-detail">
                        <OverlayTrigger placement={'bottom'} overlay={<Tooltip id={`tooltip-bottom`}>Delete reward</Tooltip>}>
                            <div className="edit-detail">
                                <img
                                    width={15}
                                    className="me-3"
                                    src={delIcon}
                                    alt=""
                                    onClick={() => {
                                        setSelectedItem(row);
                                        setShowDelModal(true);
                                    }}
                                />
                            </div>
                        </OverlayTrigger>
                    </div>
                </div>
            ),
            center: true
        }
    ];

    const updateSingle = async (selectedId, body) => {
        try {
            const token = getToken();
            if (token)
                new WebApiCalls()
                    .updateVendor(token, body, selectedId)
                    .then((res) => {
                        if (res?.code === 200) {
                            getVendorDetail(state?.vendor_id);
                            getVendorRewards(pageSize, 1, '', '', state?.vendor_id);
                            toast.success('Vendor is  updated successfully.');
                        }
                    })
                    .catch((err) => {
                        toast.success('Oops...! Something went wrong');
                    });
        } catch (error) {
            console.error('ERROR while updating Bulk', error);
        }
    };

    const handleRowSelected = React.useCallback((state) => {
        const selectedIds = state.selectedRows.map((item) => {
            return item._id;
        });
        setSelectedRows(selectedIds);
    }, []);
    const deleteBulk = async () => {
        try {
            const token = getToken();
            let obj = {
                _ids: selectedRows
            };
            if (token)
                new WebApiCalls()
                    .deleteBulkRewards(token, obj)
                    .then((res) => {
                        if (res?.code === 200) {
                            getVendorRewards(pageSize, 1, '', '', state?.vendor_id);
                            toast.success('Rewards are Delete Successfully.');
                            setToggleCleared(true);
                            setSelectedRows();
                        }
                    })
                    .catch((err) => {});
        } catch (error) {
            console.error('ERROR while updating Bulk', error);
        }
    };
    const handleClose = () => {
        setShowDelModal(false);
    };

    const searchDebounce = _.debounce((text) => {
        getVendorRewards(undefined, undefined, '', text, state?.vendor_id);
    }, 2000);

    const updateBulk = async (status) => {
        try {
            setLoading(true);
            const token = getToken();
            let obj = {
                _ids: selectedRows,
                status: status
            };
            if (token)
                new WebApiCalls()
                    .updateBulkRewards(token, obj)
                    .then((res) => {
                        if (res?.code === 200) {
                            getVendorRewards(pageSize, 1, '', '', state?.vendor_id);
                            setLoading(false);
                            toast.success('Rewards are Updated Successfully.');
                            setToggleCleared(true);
                            setSelectedRows();
                        }
                    })
                    .catch((err) => {
                        setLoading(false);
                    });
            setLoading(false);
        } catch (error) {
            console.error('ERROR while updating Bulk', error);
        }
    };
    const handleDelete = async () => {
        const token = getToken();
        if (token && selectedItem?._id) {
            new WebApiCalls()
                .deleteReward(token, selectedItem?._id)
                .then((res) => {
                    if (res?.code === 200) {
                        toast.success('Reward is deleted successfully.');
                        getVendorRewards(pageSize, 1, '', '', state?.vendor_id);
                    } else {
                        toast.error('Oops...! Something went wrong');
                    }
                })
                .catch((err) => {});
        }
    };

    return (
        <>
            <Row className="d-flex justify-content-center">
                <Col xs={12} sm={12} md={11} lg={11} className="shadow-lg p-5 m-3">
                    <Formik
                        initialValues={{
                            name: vendorDetials?.name || '',
                            email: vendorDetials?.email || '',
                            phone_number: vendorDetials?.phone_no || '',
                            vendor_website: vendorDetials?.vendor_website || '',
                            vendor_logo: vendorDetials?.logo?.url || '',
                            transit_agency: vendorDetials?.transit_agency || [],
                            location: { lat: vendorLatLng.lat, lng: vendorLatLng.lng }
                        }}
                        validationSchema={validate}
                        onSubmit={handleSubmit}
                        enableReinitialize={true}
                    >
                        {(formik) => (
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    formik.handleSubmit();
                                }}
                            >
                                <Row>
                                    <Col xs={6} sm={6} md={6} lg={6} className="mb-2">
                                        <BootstrapForm.Group>
                                            <BootstrapForm.Label>Transit Agency</BootstrapForm.Label>
                                            <ReactSelect
                                                options={transitAgencyOptions}
                                                value={formik.values.transit_agency}
                                                onChange={(selectedOptions) => formik.setFieldValue('transit_agency', selectedOptions || [])}
                                                placeholder="Select transit agency"
                                                name="transit_agency"
                                                isMulti={true}
                                                isClearable={true}
                                            />
                                            {formik.errors.transit_agency && <div className="text-danger">{formik.errors.transit_agency}</div>}
                                        </BootstrapForm.Group>
                                    </Col>
                                    <Col xs={12} sm={12} md={11} lg={6} className="mb-2">
                                        <FormField
                                            className="form-control common-input"
                                            label="Name"
                                            name="name"
                                            type="text"
                                            placeholder="Enter name"
                                            onChange={formik.handleChange}
                                            value={formik.values.name}
                                        />
                                    </Col>
                                    <Col xs={12} sm={12} md={11} lg={6} className="mb-2">
                                        <FormField
                                            className="form-control common-input"
                                            label="Email"
                                            name="email"
                                            type="text"
                                            placeholder="Enter name"
                                            onChange={formik.handleChange}
                                            value={formik.values.email}
                                        />
                                    </Col>
                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-2">
                                        <label htmlFor="transit_type">Status</label>
                                        <select value={status} onChange={(e) => setStatus(e.target.value)} name="transit_type" className="common-selector">
                                            <option value="active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </select>
                                    </Col>
                                    <Col xs={12} sm={12} md={11} lg={6} className="mb-2">
                                        <FormField
                                            className="form-control common-input"
                                            label="Phone Number"
                                            name="phone_number"
                                            type="text"
                                            placeholder="Enter phone"
                                            onChange={formik.handleChange}
                                            value={formik.values?.phone_number}
                                        />
                                    </Col>
                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-2">
                                        <label htmlFor="vendor_type">Vendor Type</label>
                                        <select value={vendorType} onChange={(e) => setVendorType(e.target.value)} name="vendor_type" className="common-selector">
                                            <option value="retail">Retail</option>
                                            <option value="health">Health</option>
                                            <option value="wellness">Wellness</option>
                                        </select>
                                    </Col>
                                    <Col xs={12} sm={12} md={11} lg={6} className="mb-2">
                                        <FormField
                                            className="form-control common-input"
                                            label="Vendor Website(Url)"
                                            name="vendor_website"
                                            type="text"
                                            placeholder="Enter Vendor Website"
                                            onChange={formik.handleChange}
                                            value={formik.values?.vendor_website}
                                        />
                                    </Col>
                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-3">
                                        <BootstrapForm.Group>
                                            <BootstrapForm.Label className="mb-0">Vendor Logo</BootstrapForm.Label>
                                            <BootstrapForm.Control
                                                type="file"
                                                className="form-control common-input"
                                                onChange={(e) => {
                                                    const { name } = e.target.files[0];
                                                    if (validateFileType(name)) {
                                                        setVendorLogo(e.target.files[0]);
                                                        setIsValidSelected(true);
                                                        setUpdateLogo(true);
                                                        return;
                                                    }
                                                    setIsValidSelected(false);
                                                    toast.error('File format is not supported!');
                                                }}
                                                name="uploadPicture"
                                            />
                                        </BootstrapForm.Group>
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={12}>
                                        <div className="config-form-container">
                                            <label className="config-legend-label">Location</label>
                                            <AddressInputWithMapClick
                                                errors={formik.errors}
                                                values={formik.values}
                                                setFieldValue={formik.setFieldValue}
                                                label="Vendor Address"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <div className="text-end">
                                    <Link to="/vendors">
                                        <Button type="submit" className="theme-cancel-btn me-3">
                                            Cancel
                                        </Button>
                                    </Link>
                                    <Button type="submit" className="theme-btn">
                                        Update
                                    </Button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                    <div>
                        <hr className="mt-3" />
                        <Row className="mt-4 mb-3">
                            <Col md={4}>
                                <div className="detail-value">Rewards Listing</div>
                            </Col>
                        </Row>

                        <Modal centered show={changeStatusModal} onHide={handleClose} size="md">
                            <Modal.Title className="text-center">
                                <h6 className="text-capitalize mt-2">
                                    <span className=" breadcrumb-heading">Change Status</span>
                                </h6>
                                <hr></hr>
                            </Modal.Title>
                            <Modal.Body className="text-center">
                                <p className="mx-4 my-4 px-5">Are you sure you want to change status?</p>
                                <div className="text-content-wrapper mt-3">
                                    <div>
                                        <Button
                                            className="add-record-btn  justify-content-center w-140"
                                            style={{ background: '#198754' }}
                                            onClick={() => {
                                                setChangeStatusModal(false);
                                                updateBulk('active');
                                            }}
                                        >
                                            Active
                                        </Button>
                                    </div>
                                    <div>
                                        <Button
                                            className="add-record-btn  justify-content-center w-140"
                                            style={{ background: '#F32013' }}
                                            onClick={() => {
                                                setChangeStatusModal(false);
                                                updateBulk('inactive');
                                            }}
                                        >
                                            Inactive
                                        </Button>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer className="border-0 mt-2"></Modal.Footer>
                        </Modal>
                        <CommonModal handleClose={handleClose} show={showDelModal} handleDelete={handleDelete} text={'Are you sure, you want to delete this Reward?'} />
                        <Row className="mb-4 mt-1">
                            <Col sm={3} md={3} style={{ paddingRight: 0 }}>
                                <input
                                    type={'search'}
                                    className="search-input-bar"
                                    placeholder={'Search here...'}
                                    onChange={(e) => {
                                        e.preventDefault();
                                        searchDebounce(e.target.value);
                                    }}
                                />
                            </Col>
                            <Col sm={4} md={4} style={{ paddingLeft: 0 }}>
                                <div className="d-flex gap-10 justify-content-start">
                                    <select
                                        onChange={(e) => {
                                            getVendorRewards(undefined, undefined, e.target.value, '', state?.vendor_id);
                                            setIsFilterSelected(e.target.value ? true : false);
                                        }}
                                        className="status-selector w-120"
                                        aria-label="Default select example"
                                        style={{ color: !isFilterSelected ? '#9a9a9a' : '' }}
                                    >
                                        <option value={''}>Status</option>
                                        <option value={'active'}>Active</option>
                                        <option value={'inactive'}>Inactive</option>
                                    </select>
                                </div>
                            </Col>
                            <Col sm={5} md={5}>
                                <div className="d-flex gap-10 justify-content-end h-100">
                                    {!buttonDisable && (
                                        <>
                                            <Button
                                                className="add-record-btn  justify-content-center w-140"
                                                style={{ background: '#F3D119', color: 'black' }}
                                                onClick={(e) => {
                                                    setChangeStatusModal(true);
                                                }}
                                                disabled={buttonDisable}
                                            >
                                                Change Status
                                            </Button>
                                            <Button
                                                className="add-record-btn  justify-content-center w-140"
                                                style={{ background: 'red' }}
                                                onClick={(e) => {
                                                    deleteBulk();
                                                }}
                                                disabled={buttonDisable}
                                            >
                                                Delete
                                            </Button>
                                        </>
                                    )}
                                    <Button
                                        className="add-record-btn justify-content-center  w-140"
                                        style={{ background: '#13aa61' }}
                                        onClick={(e) => {
                                            navigate('/reward-points/add-rewards-points', {
                                                state: {
                                                    redirect_url: '/vendors/edit-vendor',
                                                    vendor_id: state?.vendor_id,
                                                    type: state?.vendor_detail.type
                                                }
                                            });
                                        }}
                                    >
                                        Add
                                    </Button>
                                </div>
                            </Col>
                        </Row>

                        <DataTable
                            columns={columns}
                            data={rewards}
                            selectableRows
                            pagination
                            paginationServer
                            paginationTotalRows={totalRecords}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={handlePageChange}
                            progressPending={rewards && rewards?.length >= 0 ? false : true}
                            responsive
                            direction="auto"
                            fixedHeaderScrollHeight="300px"
                            subHeaderAlign="right"
                            subHeaderWrap
                            customStyles={customStyles}
                            onSelectedRowsChange={handleRowSelected}
                            clearSelectedRows={toggleCleared}
                        />
                    </div>
                </Col>
            </Row>
        </>
    );
};
export default EditVendors;
